import { render, staticRenderFns } from "./Linha2-estrategia.vue?vue&type=template&id=06373fab&scoped=true&"
import script from "./Linha2-estrategia.vue?vue&type=script&lang=js&"
export * from "./Linha2-estrategia.vue?vue&type=script&lang=js&"
import style0 from "./Linha2-estrategia.vue?vue&type=style&index=0&id=06373fab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06373fab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
